// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"bbd7f5c7","224":"9eda7a7e","921":"bbd7f5c7","937":"3ee9b6be","968":"4885e8ff"}[chunkId] + ".chunk.css";
};